import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=541bfff8&"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js&"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultiSelect.vue?vue&type=style&index=0&id=541bfff8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports